import { createFileRoute } from "@tanstack/react-router";
import { ClanWarPlanner } from "~/features/clan-war-planner/clan-war-planner.js";

export const Route = createFileRoute("/_authed/clan-war-planner/")({
  component: RouteComponent,
});

function RouteComponent() {
  return <ClanWarPlanner />;
}
